import { Alert, Box, IconButton, Image, Text } from '@chakra-ui/react'
import nygovlogo from '../assets/nygov-logo.png'
import { Avatar } from './ui/avatar'
import { LuLogOut } from "react-icons/lu";
import { useColorPalette } from './ui/color-palette-context';
import { useColorModeValue } from './ui/color-mode';
import { useAuth } from './ui/auth-context';
import { logout } from '@/api';
  
 interface HeaderProps {
    fontFamily?: string,
    hideBelow?: string,
 }

  export const Header = (props: HeaderProps) => {
    const { colorPalette } = useColorPalette();
    const { user, loading } = useAuth();

    const handleLogout = async () => {
        try {
            const { redirectUrl } = await logout();
            if (redirectUrl) {
                window.location.href = redirectUrl;
            }
        } catch (error) {
            console.error('Logout failed:', error);
        }
    }
    

    return (
      <Box role='banner' fontFamily={props.fontFamily} bg={`${colorPalette}.solid`} height={'64px'} display={'flex'} gap={'16px'} justifyContent={'space-between'} alignItems={'center'} hideBelow={props.hideBelow} >
        <Box display={'flex'} gap={'16px'} justifyContent={'flex-start'} alignItems={'center'} divideX={'2px'} divideColor={'white'}>
            <Image ml={'30px'}  height={'46px'} filter={'brightness(0) invert(100%)'} src={nygovlogo} alt='NYS Logo' />
            <Box pl={4} textAlign={'left'}>
                <Text p={0} fontWeight={'600'} lineHeight={'shorter'} fontSize={'22px'} color={'white'}>AI Assist</Text>
                <Text p={0} color={'white'} lineHeight={'shorter'} fontSize={'16px'} textWrap={"nowrap"} >powered by ITS</Text>
            </Box>
        </Box>
        <Box mr={'4rem'} ml={'4rem'}>
            <Alert.Root status={"warning"} size={"sm"}>
                <Alert.Indicator />
                    <Alert.Content>
                        <Alert.Description display={'flex'}>
                        This is a Beta test of the Gen-AI Assist application. Features are not final, and you may encounter incomplete functionality or bugs.
                        </Alert.Description>
                    </Alert.Content>
            </Alert.Root>
        </Box>
        <Box display={'flex'} gap={'16px'} justifyContent={'flex-start'} alignItems={'center'} mr={'30px'}>
            <Avatar fontFamily={props.fontFamily} name={user.name} />
            <Text color={'white'}>{user ? user.name : "Username"}</Text>
            <IconButton aria-label='Logout' onClick={handleLogout} size={'md'} variant={'ghost'} borderRadius={'full'} color={'white'} _hover={{ bg: 'colorPalette.muted', color: 'colorPalette' }} ><LuLogOut /></IconButton>
        </Box>
        </Box>

    )
  }
  